import {Fonctionnalite} from "./fonctionnalite";

export class Role {
    id: string;
    fonctionnalites?: Fonctionnalite[];

}
